import { SET_PAGE_DATA, SET_PAGE_INFO, SET_PAGE_LOAD, SET_PER_PAGE, SET_CHECK_PAGE, SET_MESSAGE_PAGE, SET_GAMECHECK, SET_RECONNECT_SETTING, SET_SCROLL_DIRECTION } from '../actions/types';

const initialState = {
   pageInfo: {
      pageType:   'unset', // toto, EOSPowerball1, EOSPowerball2, EOSPowerball3, EOSPowerball4, EOSPowerball5
      sportType:  'all',   // all, sport, esport, race
      gameType:   'all',   // all, live, prematch
      sportId:   'all',     // all, "1", "2", "3"....
      esportType: 'all'
   },
   perPage: 10,
   curPage: 1,
   isUp: false,
   totalPage: 1,
   loading: false,
   messagePage: false,
   checkData: {},
   gameCheck: {},
   reconnectSetting: {}
}

export default function (state = initialState, action) {
   switch (action.type) {
      case SET_PAGE_INFO:
         return {
            ...state,
            pageInfo: action.payload
         }
      case SET_PAGE_DATA:
         return {
            ...state,
            curPage: action.payload.page,
            totalPage: action.payload.totalPage,
         }
      case SET_SCROLL_DIRECTION:
         return {
            ...state,
            isUp: action.payload
         }
      case SET_PAGE_LOAD:
         return {
            ...state,
            loading: action.payload
         }
      case SET_PER_PAGE:
         return {
            ...state,
            perPage: action.payload
         }
      case SET_CHECK_PAGE:
         return {
            ...state,
            checkData: action.payload
         }
      case SET_MESSAGE_PAGE:
         return {
            ...state,
            messagePage: action.payload
         }
      case SET_GAMECHECK:
         return {
            ...state,
            gameCheck: action.payload
         }
      case SET_RECONNECT_SETTING:
         return {
            ...state,
            reconnectSetting: action.payload
         }
      default:
         return state;
   }
}


// WEBPACK FOOTER //
// ./src/common/reducers/pageReducer.js